import { toast } from 'react-toastify'

export const toastFail = e => {
  if (window.loggingout) {
    return ''
  }

  toast(e, {
    toastId: e,
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    type: 'error',
  })
}
